import { Camera } from './camera';
import { GCP } from './gcp';

export class Marker {
  reprojectionError?: number;

  static fromXml(markerElement: Element): Marker {
    if (!markerElement.hasAttributes()) {
      throw new Error(`Invalid marker element`);
    }

    const cameraId = Number(markerElement.getAttribute('camera_id'));
    const x = Number(markerElement.getAttribute('x'));
    const y = Number(markerElement.getAttribute('y'));
    const pinned = ['true', '1'].includes(markerElement.getAttribute('pinned') ?? '');

    return new Marker(cameraId, x, y, pinned);
  }

  static fromData(data: Marker): Marker {
    const gcp = data.gcp;
    const camera = data.camera;
    const pinned = data.pinned;

    const x = data.x;
    const left = data.left;
    const y = data.y;
    const top = data.top;

    return new Marker(camera!.id, x, y, pinned, left, top, gcp, camera);
  }
  constructor(
    public cameraId: number,
    // offset of marker in picture in x-pixels
    public x: number,
    // offset of marker in picture in y-pixels
    public y: number,
    public pinned: boolean,
    public left?: number,
    public top?: number,
    public gcp?: GCP,
    public camera?: Camera,
  ) {}
}
